let routes = [
  {
    path: '/modification-service-reference',
    component: () => import('../views/ModificationServiceReference.vue'),
    props: true
  },
  {
    path: '/modification-service-reference/:step',
    component: () => import('../views/ModificationServiceReference.vue'),
    props: true
  }
]

export default routes;